import React from "react"
import { Box, Text } from "rebass"

import RowWrapper from "./RowWrapper"
import MediasGallery from "./MediasGallery"

const RowImagesComponent = ({ data }) => {
  const {
    title,
    titleHeadingTag,
    text,
    mediasMediasGrid,
    mediasMediasGridGap,
    mediasMediasGridColumns,
    mediasMediasGallery,
    revealAnimation,
  } = data

  return (
    <RowWrapper {...data}>
      {title && text && (
        <Box
          as="header"
          justifyContent="center"
          flexDirection="column"
          px={[5]}
          pb={[5]}
        >
          {title && <Text as={titleHeadingTag}>{title}</Text>}
          {text && <Box dangerouslySetInnerHTML={{ __html: text }} />}
        </Box>
      )}

      {mediasMediasGallery && (
        <MediasGallery
          grid={mediasMediasGrid}
          gap={mediasMediasGridGap}
          columns={mediasMediasGridColumns}
          medias={mediasMediasGallery}
          revealAnimation={revealAnimation}
        />
      )}
    </RowWrapper>
  )
}

export default RowImagesComponent
